var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('embed',{attrs:{"src":_vm.url,"type":"application/pdf","id":"embed-pdf","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }